export enum Orientation {
  PORTRAIT = "portrait",
  LANDSCAPE = "landscape"
}